import { ProductKeyTypes } from '@/libraries/wpl/foundations/src/data-event-props';
import { GlobalNav } from '@/patterns/global-nav/src/nav-global';

export type UniformGlobalNavProps = {
	productKey?: ProductKeyTypes;
	showCta?: boolean;
};

const UniformGlobalNav = ({
	// This productKey is used for UFO instrumentation
	// This prop is standardized to the value `uniform`
	// See ldr/0018-set-standard-uniform-globalnav-productkey.md for more details
	productKey = 'uniform',
	showCta = true,
}: UniformGlobalNavProps) => <GlobalNav productKey={productKey} isShowTryNowLink={showCta} />;

export default UniformGlobalNav;
